// extracted by mini-css-extract-plugin
export default {"videoSplit":"videoSplit__7lhmn","section":"section__h5sII"};